//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { date } from "quasar";
import router from "../router";

export default {
  data() {
    return {
      purchaseOrders: [],
      unfilteredOrders: [],
      pickDayOptions: [],
      dateFilter: "",
      filter: "",
      pagination: {
        rowsPerPage: 6,
        page: 1,
        sortBy: "id",
        descending: false,
      },
      columns: [
        {
          name: "orderNumber",
          align: "left",
          label: this.$t("order.orderNo"),
          field: "orderNumber",
          sortable: true,
        },
        {
          name: "supplierName",
          align: "left",
          label: "Leverandør",
          field: "supplierName",
          sortable: true,
        },
        {
          name: "orderDate",
          align: "left",
          label: "Ord.Dato",
          field: "orderDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "purchaseOrderStatusId",
          align: "left",
          label: "Ordre status",
          field: "purchaseOrderStatusId",
          format: (val) => this.$t("purchaseOrder.status-" + val),
          sortable: true,
        },
        {
          name: "deliveryDate",
          align: "left",
          label: this.$t("order.deliveryDate"),
          field: "deliveryDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
      ],
    };
  },
  async mounted() {
    await this.refresh();
  },

  methods: {
    ...mapActions("main", ["getPurchaseOrdersByPickDay"]),

    async refresh() {
      this.filter = "";
      this.purchaseOrders = [];

      let daySelction = [
        "I dag",
        "I morgen",
        "Om 2 dager",
        "Om 3 dager",
        "Om 4 dager",
        "Om 5 dager",
        "Om 6 dager",
        "Om 7 dager",
      ];

      for (var i = 0; i < daySelction.length; i++) {
        this.pickDayOptions.push({
          value: i.toString(),
          label: daySelction[i],
        });
      }
      this.dateFilter = this.pickDayOptions[0].value;

      this.purchaseOrders = await this.getPurchaseOrdersByPickDay(0);
      window.dispatchEvent(new Event("resize"));
    },

    openPurchaseOrder(orderId) {
      // if (this.isRecevingMode) {
        router.push({ name: "PurchaseReceive", params: { id: orderId } });
      // } else {
      //   router.push({ name: "Purchase", params: { id: orderId } });
      // }
    },

    async getPurchaseOrders() {
      this.unfilteredOrders = await this.getPurchaseOrdersByPickDay(
        parseInt(this.dateFilter)
      );
      
      this.purchaseOrders = this.unfilteredOrders;
    },

    filterSearch(val) {
      if (!this.unfilteredOrders) {
        return;
      }     

      if (val.length > 1) {
        this.purchaseOrders = this.unfilteredOrders.filter(
          (o) =>
            o.orderNumber
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1 ||
            (o.supplierOrderNumber &&
              o.supplierOrderNumber.toLowerCase().indexOf(val.toLowerCase()) >
                -1) ||
            (o.supplierName &&
              o.supplierName.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (o.ourReference &&
              o.ourReference.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (o.orderDate &&
              o.orderDate
                .toString()
                .toLowerCase()
                .indexOf(val.toLowerCase()) > -1) ||
            (o.deliveryDate &&
              o.deliveryDate.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (o.supplierOrderNumber &&
              o.supplierOrderNumber.toLowerCase().indexOf(val.toLowerCase()) >
                -1) ||
            o.orderItems
              .filter((l) => l.productNumber != null)
              .filter(
                (l) =>
                  l.productNumber.toLowerCase().indexOf(val.toLowerCase()) > -1
              ).length > 0 ||
            o.orderItems
              .filter((l) => l.supplierProductNumber != null)
              .filter(
                (l) =>
                  l.supplierProductNumber
                    .toLowerCase()
                    .indexOf(val.toLowerCase()) > -1
              ).length > 0 ||
            o.orderItems
              .filter((l) => l.productName != null)
              .filter(
                (l) =>
                  l.productName.toLowerCase().indexOf(val.toLowerCase()) > -1
              ).length > 0 ||
            o.orderItems.filter(
              (l) =>
                l.joinedSerialNumbers &&
                l.joinedSerialNumbers.toLowerCase().indexOf(val.toLowerCase()) >
                  -1
            ).length > 0
        );
      } else {
        this.purchaseOrders = this.unfilteredOrders;
      }
    },
  },
};
